import { AlertDialog as AlertDialogPrimitive } from 'radix-ui';
import { cn } from '@/lib/utils';

export const AlertDialogOverlay = ({
  className,
  ...props
}: React.ComponentProps<typeof AlertDialogPrimitive.Overlay>) => (
  <AlertDialogPrimitive.Overlay
    data-slot="alert-dialog-overlay"
    className={cn(
      'data-open:tw-animate-in data-closed:tw-animate-out data-closed:tw-fade-out-0 data-open:tw-fade-in-0 tw-bg-black/10 tw-duration-100 supports-backdrop-filter:tw-backdrop-blur-xs tw-fixed tw-inset-0 tw-z-50',
      className,
    )}
    {...props}
  />
);
